import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";

export function isOfflineCalendarDataEnabled(mailboxInfo?: MailboxInfo): boolean {
    return isOfflineSyncEnabled(mailboxInfo) && isGlobalFeatureEnabled("fwk-offline-calendar");
}
